import React, { FC } from 'react';
import type {
  AdjusmentSource,
  AdjusmentStatus
} from '@melio/payments-recon-api-client-ts';
import { Tag } from '@tools/ui/components/common/Tag';
import {
  EnumTaskEntityCachedDataPaymentRiskStatus,
  PaymentriskStatusEnumType,
  Status as ChargebackStatus,
  TransactionsourceEnumType
} from '@tools/ui/types/generated/graphql';
import colors from '@tools/ui-utils/colors.util';
import { reconEnumValue } from '../../utils/reconEnumValue';

type TProps = {
  status?:
    | PaymentriskStatusEnumType
    | EnumTaskEntityCachedDataPaymentRiskStatus
    | ChargebackStatus
    | TransactionsourceEnumType
    | AdjusmentStatus
    | AdjusmentSource;
};

const statusColor = {
  // risk status
  [PaymentriskStatusEnumType.declined]: colors.error,
  [PaymentriskStatusEnumType.approved]: colors.green,
  [PaymentriskStatusEnumType.pending]: colors.geekblue,
  // reco status
  [TransactionsourceEnumType.svb]: colors.daybreak,
  [TransactionsourceEnumType.evolve]: colors.goldenPurple,
  // reco adjustment status
  [reconEnumValue<AdjusmentStatus>('created')]: colors.geekblue,
  [reconEnumValue<AdjusmentStatus>('alerted')]: colors.error,
  [reconEnumValue<AdjusmentStatus>('settled')]: colors.green,
  // reco adjustment source
  [reconEnumValue<AdjusmentSource>('manual')]: colors.daybreak,
  [reconEnumValue<AdjusmentSource>('automated')]: colors.goldenPurple,
  // luci status
  [ChargebackStatus.Lost]: colors.error,
  [ChargebackStatus.Recovered]: colors.green,
  [ChargebackStatus.PotentialLoss]: colors.geekblue
};

const TagStatus: FC<React.PropsWithChildren<TProps>> = ({ status }) => {
  const color = statusColor[status || ''] || colors.geekblue;

  return <Tag color={color}>{status}</Tag>;
};

export default TagStatus;
